"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Video = void 0;
var _style = _interopRequireDefault(require("styled-jsx/style"));
var _react = _interopRequireDefault(require("react"));
var _videoUtils = require("./videoUtils");
var _videoModule = _interopRequireDefault(require("./video.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _registerWidgetForDnD = require("../styles/registerWidgetForDnD");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var VIDEO_PROPS = {
  src: "",
  hideControls: false,
  muted: false,
  autoplay: false,
  width: "",
  aspectRatio: "",
  objectFit: ["cover", "contain", "fill", "none", "scale-down"],
  backgroundColor: ""
};
var DEFAULT_VIDEO = "https://www.youtube.com/watch?v=lKUQqPrRaN4";
var RawVideo = function RawVideo(props) {
  var videoUrlParts = (0, _videoUtils.getVideoParts)(props.src);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("video", {
    controls: !props.hideControls,
    autoPlay: props.autoplay,
    muted: props.muted || props.autoplay,
    style: {
      aspectRatio: props.aspectRatio,
      width: props.width,
      objectFit: props.objectFit,
      backgroundColor: props.backgroundColor
    },
    className: "jsx-".concat(_videoModule.default.__hash) + " " + ((0, _classnames.default)(props.className, "video", {
      "video-width": !props.width
    }) || "")
  }, /*#__PURE__*/_react.default.createElement("source", {
    src: props.src,
    type: videoUrlParts === null || videoUrlParts === void 0 ? void 0 : videoUrlParts.mimeType,
    className: "jsx-".concat(_videoModule.default.__hash)
  })), /*#__PURE__*/_react.default.createElement(_style.default, {
    id: _videoModule.default.__hash
  }, _videoModule.default));
};
var YTVideo = function YTVideo(props) {
  var ytVideoId = (0, _videoUtils.getYoutubeVideoId)(props.src);
  if (ytVideoId) {
    var urlParams = [];
    urlParams.push("modestbranding=1");
    urlParams.push("color=white");
    urlParams.push("playsinline=1");
    props.hideControls && urlParams.push("controls=0");
    props.autoplay && urlParams.push("autoplay=1");
    (props.muted || props.autoplay) && urlParams.push("mute=1");
    var embedUrl = "https://www.youtube.com/embed/".concat(ytVideoId, "?").concat(urlParams.join("&"));
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("iframe", {
      src: embedUrl,
      title: "YouTube",
      style: {
        aspectRatio: props.aspectRatio,
        width: props.width,
        backgroundColor: props.backgroundColor
      },
      className: "jsx-".concat(_videoModule.default.__hash) + " " + ((0, _classnames.default)(props.className, "video", {
        "video-width": !props.width
      }) || "")
    }), /*#__PURE__*/_react.default.createElement(_style.default, {
      id: _videoModule.default.__hash
    }, _videoModule.default));
  }
  return null;
};
var Video = function Video(props) {
  var _props$src = props.src,
    src = _props$src === void 0 ? DEFAULT_VIDEO : _props$src;
  var videoUrlParts = (0, _videoUtils.getVideoParts)(src);
  if ((0, _videoUtils.isYoutubeVideo)(videoUrlParts)) {
    return /*#__PURE__*/_react.default.createElement(YTVideo, props);
  }
  return /*#__PURE__*/_react.default.createElement(RawVideo, props);
};
exports.Video = Video;
(0, _registerWidgetForDnD.registerKuiWidget)({
  name: "Video",
  component: Video,
  options: VIDEO_PROPS,
  icon: "smart_display"
});